"use strict";
/*
 * This file is part of the IVMS Online.
 *
 * @copyright 2020, 2022 - 2023, 2025 - 2026 © by Rafał Wrzeszcz - Wrzasq.pl.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselsList = void 0;
const material_1 = require("@mui/material");
const react_1 = require("react");
const React = require("react");
const react_router_1 = require("react-router");
const api_1 = require("../../api");
const VesselActions_1 = require("../ui/VesselActions");
const VesselsList = () => {
    const [vessels, setVessels] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        const request = api_1.api.graphql({
            query: api_1.listVesselsQuery,
        });
        request.then(response => {
            var _a, _b, _c;
            setVessels((_c = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.listVessels) === null || _b === void 0 ? void 0 : _b.vessels) !== null && _c !== void 0 ? _c : []);
        });
        return () => {
            api_1.api.cancel(request);
        };
    }, []);
    return vessels.map(vessel => {
        var _a;
        return React.createElement(material_1.Card, { sx: { maxWidth: "25%" }, key: vessel.vesselId },
            React.createElement(material_1.CardActionArea, { component: react_router_1.Link, to: `/vessels/${vessel.vesselId}` },
                React.createElement(material_1.CardContent, null,
                    React.createElement(material_1.Typography, { gutterBottom: true, variant: "h5", component: "div" }, (_a = vessel.label) !== null && _a !== void 0 ? _a : vessel.name),
                    React.createElement(material_1.Typography, { variant: "body2", sx: { color: "text.secondary" } }, vessel.status.isOnline ? "Online" : "Offline")),
                React.createElement(material_1.CardActions, null,
                    React.createElement(VesselActions_1.VesselActions, { vessel: vessel }))));
    });
};
exports.VesselsList = VesselsList;
